import { render, staticRenderFns } from "./survival.vue?vue&type=template&id=1637e954&"
import script from "./survival.vue?vue&type=script&lang=js&"
export * from "./survival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports